import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({

	OrganizationEmpty: {
		k: "organization.missing.title",
		v: "No Organization Selected"
    },
    DescriptionEmpty:{
        k:"organization.missing.description",
        v:"Please select an organization to see the user list."
    },
    OrganizationNotFound:{
        k: "organization.notfound.title",
        v: "Organization Not Found"
    },
    OrganizationNotfoundDescription:{
        k: "organization.notfound.description",
        v: ""
    }
});



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/MessageEdit.labels.ts